import { useState } from 'react'

// Keuzestap bij versturen: de admin kiest altijd bewust de ontvangers.
// Niets is voorgeselecteerd; Verstuur blijft uit tot er een keuze is.
const SendChoiceModal = ({ title, options, hint, warning, sending, onSend, onCancel }) => {
  const [choice, setChoice] = useState(null)

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-60 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md">
        <h3 className="text-xl font-bold mb-4 text-gray-800 dark:text-white">{title}</h3>

        {warning && (
          <div className="mb-4 px-3 py-2 rounded-md bg-amber-50 dark:bg-amber-900/30 text-amber-800 dark:text-amber-200 text-sm">
            {warning}
          </div>
        )}

        <fieldset className="space-y-3">
          <legend className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Ontvangers</legend>
          {options.map((option) => (
            <label
              key={option.value}
              className={`flex items-center ${option.disabled ? 'opacity-50' : 'cursor-pointer'}`}
            >
              <input
                type="radio"
                name="send-choice"
                value={option.value}
                checked={choice === option.value}
                disabled={option.disabled || sending}
                onChange={() => setChoice(option.value)}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">{option.label}</span>
            </label>
          ))}
        </fieldset>

        {hint && (
          <p className="mt-4 text-xs text-gray-500 dark:text-gray-400">{hint}</p>
        )}

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={onCancel}
            disabled={sending}
            className="px-4 py-2 bg-gray-300 dark:bg-gray-600 text-gray-800 dark:text-white rounded-lg hover:bg-gray-400 dark:hover:bg-gray-500 disabled:opacity-50 transition-colors"
          >
            Annuleren
          </button>
          <button
            onClick={() => onSend(choice)}
            disabled={!choice || sending}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 transition-colors"
          >
            {sending ? 'Verzenden...' : 'Verstuur'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SendChoiceModal
